import { supabase } from '../lib/supabase';

const toSnakeCase = (mealData) => ({
  day_number: mealData?.dayNumber,
  meal_date: mealData?.mealDate || mealData?.date,
  meal_type: mealData?.mealType || mealData?.type,
  meal_name: mealData?.mealName || mealData?.name,
  servings: mealData?.servings,
  is_leftover: mealData?.isLeftover,
  can_yield_leftovers: mealData?.canYieldLeftovers,
  ingredients: mealData?.ingredients,
  is_selected: mealData?.isSelected
});

const toCamelCase = (row) => ({
  id: row?.id,
  tripId: row?.trip_id,
  dayNumber: row?.day_number,
  date: row?.meal_date,
  mealDate: row?.meal_date,
  type: row?.meal_type,
  mealType: row?.meal_type,
  name: row?.meal_name,
  mealName: row?.meal_name,
  servings: row?.servings,
  isLeftover: row?.is_leftover,
  canYieldLeftovers: row?.can_yield_leftovers,
  ingredients: row?.ingredients,
  isSelected: row?.is_selected,
  createdAt: row?.created_at,
  updatedAt: row?.updated_at
});

export const mealService = {
  async getMealsByTrip(tripId) {
    try {
      const { data, error } = await supabase?.from('meals')?.select('*')?.eq('trip_id', tripId)?.order('day_number', { ascending: true })?.order('meal_type', { ascending: true });
      
      if (error) throw error;
      
      return { data: data?.map(toCamelCase) || [], error: null };
    } catch (error) {
      return { data: [], error };
    }
  },

  async createMeal(tripId, mealData) {
    try {
      const { data, error } = await supabase?.from('meals')?.insert({
          trip_id: tripId,
          ...toSnakeCase(mealData)
        })?.select()?.single();
      
      if (error) throw error;
      
      return { data: toCamelCase(data), error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  async updateMeal(mealId, mealData) {
    try {
      const { data, error } = await supabase?.from('meals')?.update(toSnakeCase(mealData))?.eq('id', mealId)?.select()?.single();
      
      if (error) throw error;
      
      return { data: toCamelCase(data), error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  async deleteMeal(mealId) {
    try {
      const { error } = await supabase?.from('meals')?.delete()?.eq('id', mealId);
      
      if (error) throw error;
      
      return { error: null };
    } catch (error) {
      return { error };
    }
  },

  async bulkCreateMeals(tripId, mealsData) {
    try {
      const mealsToInsert = mealsData?.map(meal => ({
        trip_id: tripId,
        ...toSnakeCase(meal)
      }));

      const { data, error } = await supabase?.from('meals')?.insert(mealsToInsert)?.select();
      
      if (error) throw error;
      
      return { data: data?.map(toCamelCase) || [], error: null };
    } catch (error) {
      return { data: [], error };
    }
  },

  async deleteAllMealsByTrip(tripId) {
    try {
      const { error } = await supabase?.from('meals')?.delete()?.eq('trip_id', tripId);
      
      if (error) throw error;
      
      return { error: null };
    } catch (error) {
      return { error };
    }
  },

  async toggleMealSelection(mealId, isSelected) {
    try {
      const { data, error } = await supabase?.from('meals')?.update({ is_selected: isSelected })?.eq('id', mealId)?.select()?.single();
      
      if (error) throw error;
      
      return { data: toCamelCase(data), error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  async getSelectedMealsByTrip(tripId) {
    try {
      const { data, error } = await supabase?.from('meals')?.select('*')?.eq('trip_id', tripId)?.eq('is_selected', true)?.order('day_number', { ascending: true })?.order('meal_type', { ascending: true });
      
      if (error) throw error;
      
      return { data: data?.map(toCamelCase) || [], error: null };
    } catch (error) {
      return { data: [], error };
    }
  }
};